import { render, staticRenderFns } from "./TaskControlPoints.vue?vue&type=template&id=82b722a0&"
import script from "./TaskControlPoints.vue?vue&type=script&lang=js&"
export * from "./TaskControlPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports